export default __webpack_public_path__ + "static/media/Head.98a5b278.svg";